import { type RequestType } from "./types";

export interface RouteNumbers {
  transferNumberUrgent: string | null;
  transferNumberB2b: string | null;
}

const blankToNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const routeNumbersPatch = (
  allSame: boolean,
  urgent: string,
  b2b: string,
): RouteNumbers =>
  allSame
    ? { transferNumberUrgent: null, transferNumberB2b: null }
    : {
        transferNumberUrgent: blankToNull(urgent),
        transferNumberB2b: blankToNull(b2b),
      };

export const allNumbersSame = (numbers: RouteNumbers): boolean =>
  numbers.transferNumberUrgent === null && numbers.transferNumberB2b === null;

export interface TransferRequestTypeChoice {
  offerMode: string;
  b2bEnabled: boolean;
  urgentRequestTypeId: string | null;
  b2bRequestTypeId: string | null;
}

const isKnownType = (typeId: string | null, requestTypes: RequestType[]) =>
  typeId !== null && requestTypes.some((t) => t.typeId === typeId);

/** The V2 reason tag for an emergency in the default list a practice gets. */
const REALTIME_URGENT_REASON = "urgent_request";

/** Whether the V2 agent may put a caller through for the urgent reason; an empty list permits any reason. */
export const realtimeTransfersUrgentCalls = (
  agentTransfer: { enabled: boolean; reasonsAllowed: string[] } | undefined,
): boolean =>
  agentTransfer !== undefined &&
  agentTransfer.enabled &&
  (agentTransfer.reasonsAllowed.length === 0 ||
    agentTransfer.reasonsAllowed.includes(REALTIME_URGENT_REASON));

/** V2 files every urgent transfer under the urgent request type, so the type is required while the agent may make one. */
export const realtimeTransferRequestTypeErrors = (
  transfersUrgentCalls: boolean,
  urgentRequestTypeId: string | null,
  requestTypes: RequestType[],
): string[] =>
  transfersUrgentCalls && !isKnownType(urgentRequestTypeId, requestTypes)
    ? [
        "Vyberte typ požadavku pro urgentní přepojení — agent smí přepojovat urgentní hovory.",
      ]
    : [];

export const transferRequestTypeErrors = (
  choice: TransferRequestTypeChoice,
  requestTypes: RequestType[],
): string[] => {
  const errors: string[] = [];
  if (
    choice.offerMode !== "never" &&
    !isKnownType(choice.urgentRequestTypeId, requestTypes)
  ) {
    errors.push(
      "Vyberte typ požadavku pro urgentní přepojení — nabídka „stiskněte 9“ je zapnutá.",
    );
  }
  if (
    choice.b2bEnabled &&
    !isKnownType(choice.b2bRequestTypeId, requestTypes)
  ) {
    errors.push(
      "Vyberte typ požadavku pro B2B — B2B dotaz pro neznámá čísla je zapnutý.",
    );
  }
  return errors;
};

export const parseKeywordLines = (text: string): string[] =>
  text
    .split("\n")
    .map((k) => k.trim())
    .filter((k) => k.length > 0);
